import React, { createContext, useContext, useState } from 'react';

const SelectedItemsContext = createContext(null); // Ajout d'une valeur par défaut

export function useSelectedItems() {
    return useContext(SelectedItemsContext);
}

export function SelectedItemsProvider({ children }) {
    const [selectedItems, setSelectedItems] = useState([]);

    return (
        <SelectedItemsContext.Provider value={{ selectedItems, setSelectedItems }}>
            {children}
        </SelectedItemsContext.Provider>
    );
}
